export const USER_ROLES = {
  UNAPPROVED: 0,
  GUEST: 25,
  VIEWER: 50,
  // TODO: confirm the winnin-lite numeric value with the backend (placeholder).
  WINNIN_LITE: 60,
  EDITOR: 100,
  COMPANY_ADMIN: 150,
  MODERATOR: 200,
  ADMIN: 300,
  TAGGER_EDITOR: 350,
  TAGGER_ADMIN: 400,
}
